import { render, staticRenderFns } from "./ArticleAutocomplete.vue?vue&type=template&id=58a00e90&"
import script from "./ArticleAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ArticleAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports